/** Tooltips for Admin-only plan/quote line controls */
export const ADMIN_ONLY_MULTIPLIER_TIP = 'Only Administrators can change multipliers on default items.';
export const ADMIN_ONLY_DEFAULT_REMOVE_TIP = 'Only Administrators can remove default items.';
export const ADMIN_ONLY_BULK_REMOVE_DEFAULTS_TIP =
    'Selection includes default items. Only Administrators can remove default items.';
